import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import HomePage from './pages/HomePage';
import StayDetailPage from './pages/StayDetailPage';
import DiningPage from './pages/DiningPage';
import CommunityPage from './pages/CommunityPage';
import GalleryRoutePage from './pages/GalleryRoutePage';
import ExplorePage from './pages/ExplorePage';
import GettingHerePage from './pages/GettingHerePage';
import ContactPage from './pages/ContactPage';
import './index.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App" data-testid="app-container">
          {/* Grain Texture Overlay */}
          <div className="grain-overlay" aria-hidden="true" />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/lodge-room" element={<StayDetailPage type="lodges" />} />
            <Route path="/villa" element={<StayDetailPage type="villas" />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/dining" element={<DiningPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/gallery" element={<GalleryRoutePage />} />
            <Route path="/getting-here" element={<GettingHerePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
